// removed by extract-text-webpack-plugin
module.exports = {"container":"src-pages-QuestionList-index-container-22LFo","main":"src-pages-QuestionList-index-main-20Mvh","side":"src-pages-QuestionList-index-side-6ny19","header":"src-pages-QuestionList-index-header-1c86t","body":"src-pages-QuestionList-index-body-3rr87","footer":"src-pages-QuestionList-index-footer-2wdEf"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/QuestionList/index.css
 ** module id = 285
 ** module chunks = 0
 **/